import { useState } from 'react';
import { useActor } from '@xstate/react';
import { Input } from '@crazyegginc/hatch';

import { GOAL_ACTIONS } from '/src/features/goals/machines/wizard';

export function GA4Trigger({ service, triggerIndex }) {
  const [state] = useActor(service);
  const [touched, setTouched] = useState({});
  const { send } = service;
  const errors = state.context.errors?.triggers?.[triggerIndex];
  const values = state.context.payload.triggers[triggerIndex];

  return (
    <div className="mt-10 space-y-10">
      <Input
        id={`trigger-${triggerIndex}-ga4MeasurementId`}
        label="GA4 measurement ID:"
        labelClassName="!text-xl !font-semibold !mb-5 !leading-none"
        placeholder="e.g.: G-123HSDF12"
        value={values.ga4MeasurementId ?? ''}
        error={touched.ga4MeasurementId ? errors?.ga4MeasurementId : null}
        onChange={(e) => {
          setTouched((current) => ({ ...current, ga4MeasurementId: true }));
          send({
            type: GOAL_ACTIONS.SET_TRIGGER,
            index: triggerIndex,
            key: 'ga4MeasurementId',
            value: e.target.value.trim().toUpperCase(),
          });
        }}
      />

      <Input
        id={`trigger-${triggerIndex}-ga4Event`}
        label="Event name:"
        labelClassName="!text-xl !font-semibold !mb-5 !leading-none"
        placeholder="e.g.: purchase"
        value={values.ga4Event ?? ''}
        error={touched.ga4Event ? errors?.ga4Event : null}
        onChange={(e) => {
          setTouched((current) => ({ ...current, ga4Event: true }));
          send({
            type: GOAL_ACTIONS.SET_TRIGGER,
            index: triggerIndex,
            key: 'ga4Event',
            value: e.target.value.trim(),
          });
        }}
      />
    </div>
  );
}
